import React, { Component, PropTypes } from 'react';

import css from './range.scss';

export default class InputRange extends Component {
	static propTypes = {
		name: PropTypes.string.isRequired,
		value: PropTypes.number,
		min: PropTypes.number,
		max: PropTypes.number,
		lowThreshold: PropTypes.number,

		nobContent: PropTypes.oneOfType([
			PropTypes.oneOf([false]),
			PropTypes.func,
		]),
		extraData: PropTypes.object,

		onChange: PropTypes.func,
	};

	static defaultProps = {
		value: 80,
		min: 0,
		max: 100,
		lowThreshold: 80,
		hideLabel: false,

		nobContent: false,
		extraData: {},

		onChange: function() {},
	};

	constructor(props) {
		super();

		this.value = props.value;

		this.state = {
			value: props.value,
		};
	}

	shouldComponentUpdate(nextProps, nextState) {
		return (
			this.props !== nextProps ||
			this.state.value !== nextState.value
		);
	}

	componentWillReceiveProps(nextProps) {
		if (nextProps.value !== this.props.value) {
			this.value = nextProps.value;
			this.setState({
				...this.nextState,
				value: nextProps.value,
			});
		}
	}

	render() {
		let className = 'custom-range';
		let rangeStyle = {};
		let nobStyle = {};
		let rangePercentage = this.calcPercentage();
		let NobContent = this.props.nobContent;

		if (this.props.className) {
			className += ' ' + this.props.className;
		}

		if (this.props.error) {
			className += ' invalid';
		}

		rangeStyle.width = rangePercentage + '%';
		nobStyle.left = rangeStyle.width;

		if (rangePercentage < this.props.lowThreshold) {
			className += ' custom-range--low';
		}

		return (
			<div className={className}>

				{/* output input type text with all the given props as attributes */}
				<input
					key='input'
					ref='input'
					type='range'
					id={this.props.name}
					min={this.props.min}
					max={this.props.max}
					value={this.state.value}
					onChange={this.onChange.bind(this)}
					onMouseUp={this.triggerChange.bind(this)}
					onTouchEnd={this.triggerChange.bind(this)}
					className={'custom-range__input'}
				/>

				<div className='custom-range__visual'>
					<div className='custom-range__visual__range' style={rangeStyle}></div>
					<div className='custom-range__visual__knob' style={nobStyle} data-value={this.state.value}></div>
					<div className='custom-range__visual__warning' style={nobStyle}>
						{(!!NobContent) && (
							<NobContent value={this.state.value} data={this.props.extraData} />
						)}
					</div>
				</div>

				{this.renderError(this.props.error)}

			</div>
		);
	}

	renderError(errors) {
		if (typeof errors !== 'object') {
			return false;
		}

		return (
			<div className='custom-input__error'>
				{errors.map((error, i) => {
					return (
						<span key={i}>{error}</span>
					);
				})}
			</div>
		);
	}

	calcPercentage() {
		let range = (this.props.max - this.props.min);
		let unitVal = (this.state.value - this.props.min);
		let percentage = (100 / range) * unitVal;

		//console.log(`val: ${this.state.value} - perc: ${percentage}`);

		return percentage;
	}

	onChange(e) {
		if (!e || !e.target) {
			return false;
		}

		this.setState({ ...this.state, value: e.target.value });
	}

	triggerChange(e) {
		this.value = this.state.value;
		this.props.onChange(this.value);
	}
}



/** WEBPACK FOOTER **
 ** ./frontend/components/form/range/range.js
 **/